/* app/js/src/components/common/graphics-layers/layer-input.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.layers {
  width: 108px;
  flex: 0 !important;
  display: flex;
  align-items: center;
}
.layer-text {
  font-size: 12px;
  margin: 0 !important;
  margin-right: 4px !important;
}
.layer-info {
  margin: 0 !important;
  background-color: #cdd4db;
  border-radius: 50%;
  border: 3px solid #cdd4db;
  font-size: 9px;
  display: flex;
  align-items: center;
  width: 12px;
  height: 12px;
  margin-right: 13px !important;
}
.layer-input-warpper {
  position: relative;
  align-items: center;
}
.layer-input {
  text-align: end;
  width: 64px;
  height: 28px;
  border: 1px solid #e1e6eb;
  border-radius: 4px;
  padding-left: 18px;
}
.layer-input:focus-visible {
  border: 1px solid #e1e6eb;
  border-radius: 4px;
  outline: none;
}
.type-layer {
  position: absolute;
  display: flex;
  height: fit-content;
  margin: 0 !important;
  align-items: center;
  margin-left: 6px !important;
}
.type-dropdown {
  width: 52px;
  height: 21px;
  border: 1px solid #e1e6eb;
  border-radius: 4px;
}
.type-dropdown:focus-visible {
  border: 1px solid #e1e6eb;
  border-radius: 4px;
  outline: none;
}
.type-dropdown-wrapper {
  margin-top: 31px;
  position: relative;
}
.type-dropdown-wrapper:before {
  content: "";
  width: 14px;
  height: 10px;
  border-right: 1px solid #cdd4db;
  border-top: 1px solid #cdd4db;
  position: absolute;
  top: -12px;
}
.type-dropdown-wrapper:after {
  content: "";
  width: 14px;
  height: 10px;
  border-bottom: 1px solid #cdd4db;
  border-right: 1px solid #cdd4db;
  position: absolute;
  bottom: 20px;
}
.tooltip {
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted black;
}
.tooltip .tooltiptext {
  visibility: hidden;
  background-color: #555;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 50%;
  margin-left: -295px;
  opacity: 0;
  transition: opacity 0.3s;
}
.tooltip .tooltiptext::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 93%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #555 transparent transparent transparent;
}
.tooltip {
  margin: 0 !important;
  border-bottom: 0px !important;
}
.tooltip:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}
.container {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: baseline;
  -ms-flex-align: baseline;
  align-items: baseline;
}
.container div {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}
.container div:first-of-type {
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.container div span {
  font-size: 12px;
  letter-spacing: 0.1px;
  color: #7d8fa1;
}
/*# sourceMappingURL=layer-input.component.css.map */
